// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".yj[data-v-25796426]{border-radius:10px}.logo[data-v-25796426]{position:absoulte;z-index:1000;margin:auto}.logo[data-v-25796426],.logos[data-v-25796426]{width:300px;text-align:center}.logoImg[data-v-25796426]{width:272px;height:92px}@media screen and (max-width:600px){.logo[data-v-25796426]{position:absoulte;z-index:1000;margin:auto}.logo[data-v-25796426],.logos[data-v-25796426]{width:200px;text-align:center}.logoImg[data-v-25796426]{width:200px;height:68px}}", ""]);
// Exports
module.exports = exports;
